<template>
  <div class="row form-container p-3 mx-0">
    <div
      v-if="showTitle"
      class="col-12 d-flex align-items-start align-items-md-center mb-3"
    >
      <i class="far fa-exclamation-circle pr-1 form-icon" />
      <p class="m-0">
        {{ title }}
      </p>
    </div>
    <div class="col-12">
      <ValidationProvider
        v-slot="{ errors }"
        :name="controlName"
        :rules="isJustificationRequired ? 'required' : ''"
      >
        <CustomTextArea
          :value="value"
          :disabled="disabled"
          label="Justificación:"
          :maxlength="3000"
          :rows="1"
          show-char-count
          :count-classes="['d-block text-right']"
          :error="errors[0]"
          custom-error-msg="Favor escriba justificación."
          class="justification-text-area"
          @input="$emit('input', $event)"
        />
      </ValidationProvider>
    </div>
    <div v-if="showTextAreaDivider" class="col-12">
      <div class="my-2 my-md-4 form-divider" />
    </div>
    <div class="col-12">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'RequestInformationCustomForm',
  components: {
    CustomTextArea,
    ValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: '',
      meta: {
        description: 'Parámetro de entrada en el textarea',
        example: 'Texto requerido',
      },
    },
    title: {
      default:
        'El área de asistencia seleccionada debe estar acorde a las necesidades que serán atendidas en el ámbito escolar del Tab VI (I) del PEI.',
      type: String,
    },
    showTitle: {
      default: true,
      type: Boolean,
    },
    isJustificationRequired: {
      type: Boolean,
      default: true,
    },
    controlName: {
      type: String,
      required: true,
    },
    showTextAreaDivider: Boolean,
    disabled: {
      type: Boolean,
      default: () => null,
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .justification-text-area .student-search-alert-error {
  margin-top: -24px !important;
}
.form-container {
  background-color: #f7f7f7;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}

.form-icon {
  font-size: 0.9rem;
}
.form-divider {
  border: 1px solid #e2e2e2;
}

@media (max-width: 765px) {
  .form-divider {
    border: none;
  }
}
</style>
